import { MenuMode } from '../../StylableHorizontalMenu.types';
import { parseValueFromCss } from './parseCss';

const LINE_HEIGHT_NORMAL = 1.14;

const getMenuItemHeight = (cssText: string): number => {
  const borderWidth = parseValueFromCss(cssText, 'menuItem', 'border', 0);
  const padding = parseValueFromCss(cssText, 'menuItem', 'padding', 0);
  const paddingTop = parseValueFromCss(cssText, 'menuItem', 'padding-top', 0);
  const paddingBottom = parseValueFromCss(
    cssText,
    'menuItem',
    'padding-bottom',
    padding,
  );
  const fontSize = parseValueFromCss(
    cssText,
    'menuItem::label',
    'font-size',
    padding,
  );

  return (
    2 * borderWidth +
    paddingTop +
    paddingBottom +
    Math.round(fontSize * LINE_HEIGHT_NORMAL)
  );
};

const getScrollButtonWidth = (cssText: string): number => {
  const borderWidth = parseValueFromCss(cssText, 'scrollButton', 'border', 0);
  const padding = parseValueFromCss(cssText, 'scrollButton', 'padding', 0);
  const paddingLeft = parseValueFromCss(
    cssText,
    'scrollButton',
    'padding-left',
    padding,
  );
  const paddingRight = parseValueFromCss(
    cssText,
    'scrollButton',
    'padding-right',
    padding,
  );
  const iconWidth = parseValueFromCss(
    cssText,
    'scrollButton::icon',
    'width',
    0,
  );
  return borderWidth * 2 + paddingLeft + paddingRight + iconWidth;
};

// minimal limit for component resizing
export const getMinSize = (
  menuMode: MenuMode,
  cssText: string,
): { 'min-height'?: string; 'min-width': string } => {
  if (menuMode === 'scroll') {
    return {
      'min-height': `${getMenuItemHeight(cssText)}px`,
      'min-width': `${getScrollButtonWidth(cssText) * 2}px`,
    };
  }

  return {
    'min-width': 'min-content',
  };
};
